// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

export const CHART_SPACE_LEFT = gridSize * 8;
export const CHART_SPACE_RIGHT = gridSize * 4;
export const CHART_HEIGHT = gridSize * 15;
